import React from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import DefaultValueInput from '../DefaultValueInput';
import { settingShape } from '../../../../../services/repository/settingRepository/objects/setting';

function DefaultValues({ settings, onChange }) {
  return (
    <Row gutter={24}>
      {Object.entries(settings).map(([key, { label, value, valueType }]) => (
        <Col xs={24} sm={12} md={8} lg={6} xl={6} key={key}>
          <DefaultValueInput
            id={key}
            label={label}
            value={value}
            valueType={valueType}
            onChange={onChange}
          />
        </Col>
      ))}
    </Row>
  );
}

DefaultValues.propTypes = {
  settings: PropTypes.shape(settingShape).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DefaultValues;
